import { tryPromise } from "../../../../cutil/LangUtil";
import { Handler } from "../chain/TransformServiceHandlerChain";
import { JsonUtil } from "../../../../cutil/JsonUtil";
import { CustomApiTransformError } from "../error/CustomApiTransformError";
export class JsonHandler extends Handler {
    async process(request) {
        const rs = await tryPromise(request.text()); /// 需要尝试返回一个 string
        if (!rs.data) {
            throw CustomApiTransformError.default;
        }
        const json = JsonUtil.parse(rs.data);
        if (json) {
            request.setResult(json);
        }
        else {
            request.setResult(rs.data || "");
        }
        return true;
    }
}
